import type { FC } from "react";
import {
  Modal,
  ModalOverlay,
  type ModalOverlayProps,
} from "react-aria-components";
import { BufferWhileExiting } from "../helpers/bufferWhileExiting.js";
import { modal, type ModalSize } from "./modal.js";
import { ModalBackdrop } from "./modalBackdrop.js";
import { modalOverlay } from "./modalOverlay.js";
import { ModalStage } from "./modalStage.js";

export interface CenteredModalProps extends ModalOverlayProps {
  size?: ModalSize;
}

/** Container that centers a single <Dialog> with a backdrop. */
export const CenteredModal: FC<CenteredModalProps> = (props) => {
  const { size, children, ...modalOverlayProps } = props;

  return (
    <ModalOverlay {...modalOverlayProps} className={modalOverlay()}>
      <ModalBackdrop />
      <ModalStage size={size}>
        <Modal className={modal({ size })}>
          {(modalProps) => (
            <BufferWhileExiting
              isOpen={modalProps.state.isOpen}
              isExiting={modalProps.isExiting}
            >
              {typeof children === "function" ? children(modalProps) : children}
            </BufferWhileExiting>
          )}
        </Modal>
      </ModalStage>
    </ModalOverlay>
  );
};
